import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-file-upload-ui',
  templateUrl: './file-upload-ui.component.html',
  styleUrls: ['./file-upload-ui.component.scss']
})
export class FileUploadUiComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
